import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import { getInlineLoader } from "../Helpers";
import { IoMdCheckmarkCircleOutline } from "react-icons/io";
import { FaArrowCircleRight } from "react-icons/fa";
import HorizontalImageStrip from "./HorizontalImagesStrip";

export default function HomeBanner2(props) {

	const appContext = useContext(AppContext);

	/* Place states here */
	const [ ready, setReady ] = useState(false);

	async function init() {
		setReady(false);
		// initializations...
		setReady(true);
	}

	useEffect(() => {
		init();
	}, []);

	

	if (ready) {
		return (
			<div 
				className="MainBodySection bg-primary"
				style={{
					paddingTop: "50px",
					paddingBottom: "50px"
				}}
			>
				
				<div 
					className="container"
					
				>
					
				
					<div className="row">

						<div className="col-md-12">
							<h1
								style={{
									fontSize: "22px",
									paddingTop: "30px",
									paddingBottom: "30px"
								}}
								className="font-light text-center"
							>
								
								<span
									style={{
										fontSize: "48px"
									}}
									className="font-bold"
								>
									Tanzania Youth Integrated Development Initiative
								</span>

								<br/>

								

								<span
									style={{
										fontSize: "54px",
										textTransform: "uppercase"
									}}
									className="font-bold text-dark"
								>
									TYIDI
								</span>

								<br/>
								<br/>

								is a non-profit, youth-driven
                organization dedicated to empowering youth engaged in sustainable, equitable, youth-based
                development solutions in neglected Tanzanian communities,. TYIDI works to promote inclusive
                economic development by strengthening youth capacities, enhancing access to reliable
                innovation solution, and addressing the structural challenges that limit fair and transparent of
                youths issues

							</h1>

							<div className="text-center mt-2">
								<button
									className="btn btn-padded btn-rounded btn-light"
									onClick={() => {
										appContext.navTo({
											item: 'about_us'
										})
									}}
								>
									About Us
								</button>
							</div>

              <div className="text-center mt-4">
								<button
									className="btn btn-padded btn-rounded btn-dark"
									onClick={() => {
										appContext.navTo({
											item: 'donate'
										})
									}}
								>
									Donate
								</button>
							</div>

						</div>


						

						
					</div>

					
				</div>
					
				
			</div>
		);
	} else {
		return (
			<div className="container mSupportLoading">
				{getInlineLoader()}
			</div>
		);
	}
}
